import styled from '@emotion/styled';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { segment } from '@actions/analytics';
import { useSelectorToStore } from '@hooks/reduxHooks';
import Button from '@base/Button/Button';
import { getBatchByUID } from '@selectors/batchGroups';
import { PLATFORM_BATCH_PAGE, PLATFORM_BATCH_SHARED } from '@constants/segment';
import Share from '@icon/Share';
import useGoalEventProps from '@hooks/useGoalEventProps';
import ShareDialog from '@comp/ShareDialog/ShareDialog';
import Dialog from '@comp/Dialog/Dialog';
import { mediaQuery, Spacings } from '@styles/index';
import usePlatformEventProps from '@hooks/usePlatformBatchEventProps';

const ShareButton = styled(Button)`
  margin-left: ${Spacings.SPACING_4B};
  width: 48px;
  height: 48px;
  border-radius: ${Spacings.SPACING_2B};
  & > div {
    margin-right: ${Spacings.SPACING_0B};
  }
  ${mediaQuery.uptoMobile} {
    & > div {
      display: flex;
      justify-content: center;
    }
    margin: ${Spacings.SPACING_0B};
    margin-left: ${Spacings.SPACING_2B};
  }
`;

const BatchShare = ({ batchUID }) => {
  const [showShareOptions, setShowShareOptions] = useState(false);
  const closeShareOptiopns = () => setShowShareOptions(false);
  const batch = useSelectorToStore(getBatchByUID(batchUID));
  const batchGoalUID = batch?.goal?.uid;

  const goalSegmentData = useGoalEventProps({ goalUID: batchGoalUID });
  const segmentData = usePlatformEventProps({
    batch,
    lastPrimarySourceSection: `${PLATFORM_BATCH_PAGE} - Page Header`,
    isBatch: true,
    isSlashedPriceType: true,
    extraProps: { ...goalSegmentData, price: batch.price }
  });

  const handleShare = () => {
    segment.track(PLATFORM_BATCH_SHARED, segmentData);
    setShowShareOptions(true);
  };

  return (
    <>
      <ShareButton
        variant="hollow"
        color="black"
        icon={
          <Share size={Spacings.SPACING_6B} color="var(--color-text-primary)" />
        }
        onClick={handleShare}
      />
      <Dialog onClose={closeShareOptiopns} dialogState={showShareOptions}>
        <ShareDialog data={batch} />
      </Dialog>
    </>
  );
};

export default BatchShare;

BatchShare.propTypes = {
  batchUID: PropTypes.string.isRequired
};
